'use strict';

import {RedocComponent, BaseComponent, SchemaManager} from '../base';
import JsonPointer from '../../utils/JsonPointer';
import { JsonSchema } from '../JsonSchema/json-schema';
import { JsonSchemaLazy } from '../JsonSchema/json-schema-lazy';
import { Zippy } from '../../shared/components/index';
import { statusCodeType } from '../../utils/helpers';
import { OptionsService } from '../../services/index';

function isNumeric(n) {
  return (!isNaN(parseFloat(n)) && isFinite(n));
}

@RedocComponent({
  selector: 'responses-list',
  template: `
    <h2 class="responses-list-header" *ngIf="data.responses.length"> Responses </h2>
    <zippy *ngFor="let response of data.responses" title="{{response.code}} {{response.description}}"
      [type]="response.type" [empty]="response.empty" (open)="lazySchema.load()">
      <div *ngIf="response.headers" class="response-headers">
        <header>
          Headers
        </header>
        <div class="header" *ngFor="let header of response.headers">
          <div class="header-name"> {{header.name}} </div>
          <div class="header-type"> {{header.type}} </div>
          <div class="header-description" innerHtml="{{header.description | marked}}"> </div>
        </div>
      </div>
      <json-schema *ngIf="response.schema && options.disableLazySchemas" class="schema type" pointer="{{response.pointer}}/schema">
      </json-schema>
      <json-schema-lazy #lazySchema pointer="{{response.schema ? response.pointer + '/schema' : null}}">
      </json-schema-lazy>
    </zippy>
  `,
  styles: [`
    .responses-list-header{font-size:18px;padding:0.2em 0;margin:3em 0 1.1em 0;color:#253137;font-weight:normal}:host .zippy-title{font-family:Montserrat,sans-serif}.header-name{font-weight:bold;display:inline-block}.header-type{display:inline-block;font-weight:bold;color:#999}header{font-size:14px;font-weight:bold;text-transform:uppercase;margin-bottom:15px}.header{margin-bottom:10px}
  `],
  directives: [JsonSchema, Zippy, JsonSchemaLazy]
})
@Reflect.metadata('parameters', [[SchemaManager], [OptionsService]])
export class ResponsesList extends BaseComponent {
  constructor(schemaMgr, optionsMgr) {
    super(schemaMgr);
    this.options = optionsMgr.options;
  }

  prepareModel() {
    this.data = {};
    this.data.responses = [];

    let responses = this.componentSchema;
    if (!responses) return;

    responses = Object.keys(responses).filter(respCode => {
      // only response-codes and "default"
      return ( isNumeric(respCode) || (respCode === 'default'));
    }).map(respCode => {
      let resp = responses[respCode];
      resp.pointer = JsonPointer.join(this.pointer, respCode);
      if (resp.$ref) {
        let ref = resp.$ref;
        resp = this.schemaMgr.byPointer(resp.$ref);
        resp.pointer = ref;
      }

      resp.empty = !resp.schema;
      resp.code = respCode;
      resp.type = statusCodeType(resp.code);
      if (resp.headers) {
        resp.headers = Object.keys(resp.headers).map((k) => {
          let respInfo = resp.headers[k];
          respInfo.name = k;
          return respInfo;
        });
        resp.empty = false;
      }
      resp.extendable = resp.headers || resp.length;
      return resp;
    });
    this.data.responses = responses;
  }
}
